<template>
  <v-app style="background: #FAFAFA;">
    <v-layout justify-center>
      <app-navigation></app-navigation>
      <v-content transition="slide-x-transition">
        <router-view></router-view>
      </v-content>
      <app-footer></app-footer>
    </v-layout>
  </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'App',
  components: {
    AppNavigation,
    AppFooter,
  },
};
</script>

<style></style>
